import React, { useState } from "react";
import {
  FormContainer,
  FormTitle,
  Label,
} from "components/ConfigHotel/StyledCard";
import {
  Input,
  FormGroup,
} from "pages/Admin/DashboardAdmin/HotelConfig/Hotel/StyledHotel";
import { ChromePicker } from "react-color";
import { ButtonRow } from "pages/Admin/DashboardAdmin/HotelConfig/Hotel/StyledHotel";
import { toast } from "react-toastify";
import { useUpdateCharteGraphiqueMutation } from "actions/CharteGraphic/mutations";

const CouleurComponent = ({ selectedHotel }) => {
  const [colorPickerVisible, setColorPickerVisible] = useState({
    boutons: false,
    footer: false,
    header: false,
  });

  const [color, setColor] = useState({
    boutons: selectedHotel?.chart_graphique?.couleur_button || "",
    footer: selectedHotel?.chart_graphique?.couleur_footer || "",
    header: selectedHotel?.chart_graphique?.couleur_hearder || "",
  });

  const [loading, setLoading] = useState(false);
  const [updateCharteGraphique] = useUpdateCharteGraphiqueMutation();

  const handleColorChange = (updatedColor, name) => {
    const colorHex = updatedColor.hex;
    setColor((prev) => ({ ...prev, [name]: colorHex }));
  };

  const toggleColorPicker = (field) => {
    setColorPickerVisible((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSave = async () => {
    setLoading(true);
    const formDataToSend = new FormData();
    formDataToSend.append("couleur_button", color.boutons);
    formDataToSend.append("couleur_hearder", color.header);
    formDataToSend.append("couleur_footer", color.footer);

    try {
      const chartGraphiqueId = selectedHotel.chart_graphique.id;
      await updateCharteGraphique({
        id: chartGraphiqueId,
        hotelierData: formDataToSend,
      });
      toast.success("Couleurs de charte graphique mises à jour avec succès");
    } catch (error) {
      toast.error("Error updating charte graphique: " + error.message);
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card" style={{ backgroundColor: "#F3F3F3" }}>
      <div className="card-body">
        <FormContainer>
          <div className="row">
            <FormTitle>Couleurs</FormTitle>
            <div className="col-md-6">
              <FormGroup>
                <Label>Couleur des boutons</Label>
                <Input
                  type="text"
                  name="couleur_boutons"
                  value={color.boutons}
                  onClick={() => toggleColorPicker("boutons")}
                  readOnly
                />
                {colorPickerVisible.boutons && (
                  <ChromePicker
                    color={color.boutons}
                    onChange={(updatedColor) =>
                      handleColorChange(updatedColor, "boutons")
                    }
                  />
                )}
              </FormGroup>
              <FormGroup>
                <Label>Couleur du footer</Label>
                <Input
                  type="text"
                  name="couleur_footer"
                  value={color.footer}
                  onClick={() => toggleColorPicker("footer")}
                  readOnly
                />
                {colorPickerVisible.footer && (
                  <ChromePicker
                    color={color.footer}
                    onChange={(updatedColor) =>
                      handleColorChange(updatedColor, "footer")
                    }
                  />
                )}
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Couleur du header</Label>
                <Input
                  type="text"
                  name="couleur_header"
                  value={color.header}
                  onClick={() => toggleColorPicker("header")}
                  readOnly
                />
                {colorPickerVisible.header && (
                  <ChromePicker
                    color={color.header}
                    onChange={(updatedColor) =>
                      handleColorChange(updatedColor, "header")
                    }
                  />
                )}
              </FormGroup>
            </div>
            <ButtonRow>
              <button
                type="button"
                className="btn"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? "Chargement..." : "Sauvegarder"}
              </button>
            </ButtonRow>
          </div>
        </FormContainer>
      </div>
    </div>
  );
};

export default CouleurComponent;
